import { render } from "./IconExpandWide.vue?vue&type=template&id=4a4beaa8"
import script from "./IconExpandWide.vue?vue&type=script&lang=ts"
export * from "./IconExpandWide.vue?vue&type=script&lang=ts"
script.render = render

export default script